// The purpose of this file is store form field constraints (rules, messages) for a HTML form.
// Note that this data is kept separate from the implementation of the system that stores and retrieves data,
// which is located in the 'core' directory.

// Grab a reference to the application data store object.
var dataStore = app.data;

// Create data and store it. Note that validation messages should be overriden by the server
// in the cshtml view files, to cater for different languages. The message values here are just fallbacks.
// Things should take the format of: fieldName[validatorType] = { message: "My custom message" } as per https://validatejs.org/

var enterSubmitConstraintsSizeFunction = function (data) {

    var $inputElem = data.constraint.getFormField();
    var $valElem = $inputElem.closest('[data-maxlength]');
    var val = parseInt($valElem.data('maxlength'));

    return val;
};

var enterSubmitConstraintsValidExtensions = ['jpeg', 'jpg', 'png'];
var enterSubmitConstraintsMaxFileSize = 5; // 5MB

dataStore.set('validation.enterFormSubmit', {
    entryCategories: [
        {
            type: 'minItems',
            errorCode: 10059,
            params: {
                size: 1
            }
        }
    ],
    projectName: [
        {
            type: 'present',
            errorCode: 10009
        },
        {
            type: 'maxLength',
            params: {
                size: enterSubmitConstraintsSizeFunction
            },
            errorCode: 10026
        }
    ],
    projectNameAlternateLanguage: [
        {
            type: 'present',
            errorCode: 10063,
            severity: 'ignored'
        },
        {
            type: 'maxLength',
            params: {
                size: enterSubmitConstraintsSizeFunction
            },
            errorCode: 10080,
            severity: 'ignored'
        }
    ],
    projectDescription: [
        {
            type: 'present',
            errorCode: 10010
        },
        {
            type: 'maxLength',
            params: {
                size: enterSubmitConstraintsSizeFunction
            },
            errorCode: 10019
        }
    ],
    projectDescriptionAlternateLanguage: [
        {
            type: 'present',
            errorCode: 10064,
            severity: 'ignored'
        },
        {
            type: 'maxLength',
            params: {
                size: enterSubmitConstraintsSizeFunction
            },
            errorCode: 10073,
            severity: 'ignored'
        }
    ],
    whatItDoes: [
        {
            type: 'present',
            errorCode: 10011
        },
        {
            type: 'maxLength',
            params: {
                size: enterSubmitConstraintsSizeFunction
            },
            errorCode: 10020
        }
    ],
    whatItDoesAlternateLanguage: [
        {
            type: 'present',
            errorCode: 10065,
            severity: 'ignored'
        },
        {
            type: 'maxLength',
            params: {
                size: enterSubmitConstraintsSizeFunction
            },
            errorCode: 10074,
            severity: 'ignored'
        }
    ],
    yourInspiration: [
        {
            type: 'present',
            errorCode: 10061
        },
        {
            type: 'maxLength',
            params: {
                size: enterSubmitConstraintsSizeFunction
            },
            errorCode: 10062
        }
    ],
    yourInspirationAlternateLanguage: [
        {
            type: 'present',
            errorCode: 10070,
            severity: 'ignored'
        },
        {
            type: 'maxLength',
            params: {
                size: enterSubmitConstraintsSizeFunction
            },
            errorCode: 10081,
            severity: 'ignored'
        }
    ],
    howItWorks: [
        {
            type: 'present',
            errorCode: 10012
        },
        {
            type: 'maxLength',
            params: {
                size: enterSubmitConstraintsSizeFunction
            },
            errorCode: 10021
        }
    ],
    howItWorksAlternateLanguage: [
        {
            type: 'present',
            errorCode: 10066,
            severity: 'ignored'
        },
        {
            type: 'maxLength',
            params: {
                size: enterSubmitConstraintsSizeFunction
            },
            errorCode: 10075,
            severity: 'ignored'
        }
    ],
    designProcess: [
        {
            type: 'present',
            errorCode: 10013
        },
        {
            type: 'maxLength',
            params: {
                size: enterSubmitConstraintsSizeFunction
            },
            errorCode: 10022
        }
    ],
    designProcessAlternateLanguage: [
        {
            type: 'present',
            errorCode: 10067,
            severity: 'ignored'
        },
        {
            type: 'maxLength',
            params: {
                size: enterSubmitConstraintsSizeFunction
            },
            errorCode: 10076,
            severity: 'ignored'
        }
    ],
    howIsItDifferent: [
        {
            type: 'present',
            errorCode: 10014
        },
        {
            type: 'maxLength',
            params: {
                size: enterSubmitConstraintsSizeFunction
            },
            errorCode: 10023
        }
    ],
    howIsItDifferentAlternateLanguage: [
        {
            type: 'present',
            errorCode: 10068,
            severity: 'ignored'
        },
        {
            type: 'maxLength',
            params: {
                size: enterSubmitConstraintsSizeFunction
            },
            errorCode: 10077,
            severity: 'ignored'
        }
    ],
    futurePlans: [
        {
            type: 'present',
            errorCode: 10015
        },
        {
            type: 'maxLength',
            params: {
                size: enterSubmitConstraintsSizeFunction
            },
            errorCode: 10024
        }
    ],
    futurePlansAlternateLanguage: [
        {
            type: 'present',
            errorCode: 10069,
            severity: 'ignored'
        },
        {
            type: 'maxLength',
            params: {
                size: enterSubmitConstraintsSizeFunction
            },
            errorCode: 10078,
            severity: 'ignored'
        }
    ],
    awards: [
        {
            type: 'maxLength',
            params: {
                size: enterSubmitConstraintsSizeFunction
            },
            errorCode: 10025
        }
    ],
    awardsAlternateLanguage: [
        {
            type: 'maxLength',
            params: {
                size: enterSubmitConstraintsSizeFunction
            },
            errorCode: 10079,
            severity: 'ignored'
        }
    ],
    'imageDocumentId-1': [
        {
            type: 'present',
            errorCode: 10034
        }
    ],
    'imageFile-1': [
        {
            type: 'fileType',
            params: { validExtensions: enterSubmitConstraintsValidExtensions },
            errorCode: 10032
        },
        {
            type: 'maxFileSize',
            params: { size: enterSubmitConstraintsMaxFileSize },
            errorCode: 10033
        }
    ],
    'imageFile-2': [
        {
            type: 'fileType',
            params: { validExtensions: enterSubmitConstraintsValidExtensions },
            errorCode: 10032
        },
        {
            type: 'maxFileSize',
            params: { size: enterSubmitConstraintsMaxFileSize },
            errorCode: 10033
        }
    ],
    'imageFile-3': [
        {
            type: 'fileType',
            params: { validExtensions: enterSubmitConstraintsValidExtensions },
            errorCode: 10032
        },
        {
            type: 'maxFileSize',
            params: { size: enterSubmitConstraintsMaxFileSize },
            errorCode: 10033
        }
    ],
    'imageFile-4': [
        {
            type: 'fileType',
            params: { validExtensions: enterSubmitConstraintsValidExtensions },
            errorCode: 10032
        },
        {
            type: 'maxFileSize',
            params: { size: enterSubmitConstraintsMaxFileSize },
            errorCode: 10033
        }
    ],
    'imageFile-5': [
        {
            type: 'fileType',
            params: { validExtensions: enterSubmitConstraintsValidExtensions },
            errorCode: 10032
        },
        {
            type: 'maxFileSize',
            params: { size: enterSubmitConstraintsMaxFileSize },
            errorCode: 10033
        }
    ],
    'imageCaption-1': [
        {
            type: 'present',
            params: { validExtensions: enterSubmitConstraintsValidExtensions },
            errorCode: 10060
        },
        {
            type: 'maxLength',
            params: { size: enterSubmitConstraintsSizeFunction }
        },
        {
            type: 'requiresField',
            params: { requiredFieldId: 'imageDocumentId-1' },
            errorCode: 10090
        }
    ],
    'imageCaption-1-AlternateLanguage': [
        {
            type: 'present',
            params: { validExtensions: enterSubmitConstraintsValidExtensions },
            errorCode: 10072,
            severity: 'ignored'
        },
        {
            type: 'maxLength',
            params: { size: enterSubmitConstraintsSizeFunction },
            severity: 'ignored'
        },
        {
            type: 'requiresField',
            params: { requiredFieldId: 'imageDocumentId-1' },
            errorCode: 10091,
            severity: 'ignored'
        }
    ],
    'imageCaption-2': [
        {
            type: 'maxLength',
            params: { size: enterSubmitConstraintsSizeFunction }
        },
        {
            type: 'requiresField',
            params: { requiredFieldId: 'imageDocumentId-2' },
            errorCode: 10090
        }
    ],
    'imageCaption-2-AlternateLanguage': [
        {
            type: 'maxLength',
            params: { size: enterSubmitConstraintsSizeFunction },
            severity: 'ignored'
        },
        {
            type: 'requiresField',
            params: { requiredFieldId: 'imageDocumentId-2' },
            errorCode: 10091,
            severity: 'ignored'
        }
    ],
    'imageCaption-3': [
        {
            type: 'maxLength',
            params: { size: enterSubmitConstraintsSizeFunction }
        },
        {
            type: 'requiresField',
            params: { requiredFieldId: 'imageDocumentId-3' },
            errorCode: 10090
        }
    ],
    'imageCaption-3-AlternateLanguage': [
        {
            type: 'maxLength',
            params: { size: enterSubmitConstraintsSizeFunction },
            severity: 'ignored'
        },
        {
            type: 'requiresField',
            params: { requiredFieldId: 'imageDocumentId-3' },
            errorCode: 10091,
            severity: 'ignored'
        }
    ],
    'imageCaption-4': [
        {
            type: 'maxLength',
            params: { size: enterSubmitConstraintsSizeFunction }
        },
        {
            type: 'requiresField',
            params: { requiredFieldId: 'imageDocumentId-4' },
            errorCode: 10090
        }
    ],
    'imageCaption-4-AlternateLanguage': [
        {
            type: 'maxLength',
            params: { size: enterSubmitConstraintsSizeFunction },
            severity: 'ignored'
        },
        {
            type: 'requiresField',
            params: { requiredFieldId: 'imageDocumentId-4' },
            errorCode: 10091,
            severity: 'ignored'
        }
    ],
    'imageCaption-5': [
        {
            type: 'maxLength',
            params: { size: enterSubmitConstraintsSizeFunction }
        },
        {
            type: 'requiresField',
            params: { requiredFieldId: 'imageDocumentId-5' },
            errorCode: 10090
        }
    ],
    'imageCaption-5-AlternateLanguage': [
        {
            type: 'maxLength',
            params: { size: enterSubmitConstraintsSizeFunction },
            severity: 'ignored'
        },
        {
            type: 'requiresField',
            params: { requiredFieldId: 'imageDocumentId-5' },
            errorCode: 10091,
            severity: 'ignored'
        }
    ],
    teamMembers: [
        {
            type: 'present',
            errorCode: 10035
        },
        {
            type: 'email',
        },
        {
            type: 'minItems',
            params: {
                size: 1
            }
        },
        {
            type: 'inArray',
            params: {
                allowedValues: [] // Set via AJAX during lifecycle of application
            },
            errorCode: 10036
        },
        {
            type: 'unique',
            errorCode: 10092
        },
        {
            type: 'notEqualToField',
            params: {
                comparatorFieldId: 'lead-team-member-input'
            },
            errorCode: 10093
        }
    ]
});
